import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { PrimeCalendarComponent } from './prime-calendar/prime-calendar.component';
const routes: Routes = [
  { path: 'calendar', component: PrimeCalendarComponent, canActivate: [AuthGuard] }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrimecalendarRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/primecalendar/primecalendar-routing.module.ts